import script from "./TicketsHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketsHistory.vue?vue&type=script&setup=true&lang=js"

import "./TicketsHistory.vue?vue&type=style&index=0&id=b00a29f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b00a29f4"]])

export default __exports__